// Styles
import '../scss/main.scss';

// Scripts
import '@shop/frontend/dist/mobile/index';
import '/vendor/js/slick.js';

jQuery(function () {
  $('.s6-testi-in').slick({
    dots: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 8000,
    adaptiveHeight: true,
    fade: false,
    focusOnSelect: false,
  });
});

$(function () {
  const $popup = $('#contact-popup');
  const $form = $('#contact-form');
  const $success = $('#contact-success');
  const fields = ['name', 'email', 'message'];

  $('#contact-link').on('click', function (e) {
    e.preventDefault();
    $popup.css('display', 'flex');
  });

  $('#contact-close').on('click', function () {
    closeContactPopup();
  });

  $(window).on('click', function (e) {
    if ($(e.target).is($popup)) {
      closeContactPopup();
    }
  });

  function showError(id, message) {
    $('#error-' + id).text(message);
  }

  function clearError(id) {
    showError(id, '');
  }

  function clearErrors() {
    fields.forEach(function (field) {
      clearError(field);
    });
  }

  function validateField(field, force = false) {
    const value = $('#contact-' + field)
      .val()
      .trim();

    if (!force && !value) {
      clearError(field);
      return true;
    }

    if (field === 'name') {
      if (!value) {
        showError('name', 'Please enter your first name.');
        return false;
      }
    }

    if (field === 'email') {
      if (!value) {
        showError('email', 'Please enter your email.');
        return false;
      }

      if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(value)) {
        showError('email', 'Please enter a valid email.');
        return false;
      }
    }

    if (field === 'message') {
      if (!value) {
        showError('message', 'Please enter your message.');
        return false;
      }
    }

    clearError(field);
    return true;
  }

  function validateContactForm() {
    let valid = true;

    fields.forEach(function (field) {
      touchedFields[field] = true;

      if (!validateField(field, true)) {
        valid = false;
      }
    });

    return valid;
  }

  const touchedFields = {};

  $('#contact-name, #contact-email, #contact-message').on('blur', function () {
    const field = this.id.replace('contact-', '');

    touchedFields[field] = true;

    validateField(field);
  });

  $('#contact-name, #contact-email, #contact-message').on('input', function () {
    const field = this.id.replace('contact-', '');

    if (!touchedFields[field]) {
      return;
    }

    validateField(field, true);
  });

  $form.on('submit', function (e) {
    e.preventDefault();

    if (!validateContactForm()) return;

    $form.find('input, textarea, button').prop('disabled', true);

    setTimeout(function () {
      $success.show();

      $form.find('input, textarea, button').hide();
    }, 700);
  });

  function resetContactForm() {
    $form[0].reset();

    $success.hide();

    $form.find('input, textarea, button').each(function () {
      $(this).prop('disabled', false).show();
    });

    for (const key in touchedFields) {
      delete touchedFields[key];
    }

    clearErrors();
  }

  function closeContactPopup() {
    $popup.hide();
    resetContactForm();
  }
});
